import React from 'react'
import styled from 'styled-components'
import { numberFormat } from 'estimate_list/libs/util'

const ItemMallArea = ({ data }) => {
    return (
        <MallArea>
            <div className="mall_title">
                <div className="mall">쇼핑몰별 최저가</div>
            </div>
            {(data.market && data.market.length > 0) && (
                <ul className="mall_list">
                    {data.market.map((v, i) => (
                        <li key={i}>
                            <a href={v.link} className="mall_item" target="_blank" rel="noopener noreferrer">
                                <span className="mall_info">
                                    {v.mall_name}
                                </span>
                                <span className="price">
                                    {i === 0 && <i className="icon-arrow_down"/>}
                                    {numberFormat(v.price_b2c)}
                                </span>
                            </a>
                        </li>
                    ))}
                </ul>
            )}
        </MallArea>
    )
}

const MallArea = styled.div`
    position: relative;
    display: table-cell;
    width: 170px;
    padding-left: 16px;
    border-left: 1px solid #c8c8c8;
    vertical-align: top;

    .mall_title {
        position: relative;
        margin: 1px 0 7px;
        font-weight: 700;
        font-size: 13px;
    }
    .mall_list {
        padding: 4px 0 0;

        li {
            &:first-child {
                .mall_info {
                    color: #418ded
                }
                .price {
                    color: #f34522;

                    i {
                        font-size: 10px;
                        margin: 0 3px 0 0;
                    }
                }
            }

            .mall_item {
                display: flex;
                padding-top: 3px;
                line-height: 18px;
                color: #999;

                &:hover {
                    .mall_info,
                    .price {
                        text-decoration: underline
                    }
                }
            }
            .mall_info {
                display: block;
                max-width: 70px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                display: block;
            }
            .price {
                display: inline-block;
                flex-shrink: 0;
                margin-left: auto;
                text-align: right;
                vertical-align: top;
            }
        }
    }
`

export default ItemMallArea



// WEBPACK FOOTER //
// ./src/estimate_list/components/list/item_mall_area.js